import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotfoundpageComponent } from './notfoundpage.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { appRoutes } from './notfoundpage.routing';
import { TranslateService } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(appRoutes),
  ],
  declarations: [NotfoundpageComponent]
})
export class NotfoundpageModule { 
  constructor( translate:TranslateService) {}
 }
